// App.jsx
import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [content, setContent] = useState('');
  const [qrCodes, setQrCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('generate');

  const API_URL = 'https://qrcode_bkend.lukezhang97.com';  // Update this for production

  // Load history on initial render
  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const response = await fetch(`${API_URL}/history/`);
      if (!response.ok) {
        throw new Error('Failed to fetch history');
      }
      const data = await response.json();
      setQrCodes(data);
    } catch (err) {
      console.error('Error fetching history:', err);
      setError('Failed to load QR code history');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!content.trim()) {
      setError('Please enter content for the QR code');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const formData = new FormData();
      formData.append('content', content);

      const response = await fetch(`${API_URL}/generate/`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to generate QR code');
      }

      const data = await response.json();
      
      // Add the new QR code to the history
      setQrCodes([data, ...qrCodes]);
      
      // Switch to the history tab to show the generated QR code
      setActiveTab('history');
      
      // Clear the input field
      setContent('');
    } catch (err) {
      console.error('Error generating QR code:', err);
      setError('Failed to generate QR code');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${API_URL}/qrcode/${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Failed to delete QR code');
      }

      // Remove the deleted QR code from the state
      setQrCodes(qrCodes.filter(qr => qr.id !== id));
    } catch (err) {
      console.error('Error deleting QR code:', err);
      setError('Failed to delete QR code');
    }
  };

  const downloadQrCode = (imageData, content) => {
    const link = document.createElement('a');
    link.href = imageData;
    link.download = `qrcode-${content.substring(0, 20)}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="app-container">
      <header>
        <h1>Simple QR Code Generator</h1>
        <div className="tabs">
          <button 
            className={activeTab === 'generate' ? 'active' : ''} 
            onClick={() => setActiveTab('generate')}
          >
            Generate
          </button>
          <button 
            className={activeTab === 'history' ? 'active' : ''} 
            onClick={() => setActiveTab('history')}
          >
            History
          </button>
        </div>
      </header>

      <main>
        {activeTab === 'generate' && (
          <div className="generate-container">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="content">Enter text or URL:</label>
                <textarea
                  id="content"
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  placeholder="Enter the content for your QR code"
                  rows="4"
                />
              </div>
              
              {error && <div className="error-message">{error}</div>}
              
              <button type="submit" disabled={loading || !content.trim()}>
                {loading ? 'Generating...' : 'Generate QR Code'}
              </button>
            </form>
          </div>
        )}

        {activeTab === 'history' && (
          <div className="history-container">
            <h2>QR Code History</h2>
            
            {qrCodes.length === 0 ? (
              <p>No QR codes generated yet.</p>
            ) : (
              <div className="qr-list">
                {qrCodes.map((qr) => (
                  <div key={qr.id} className="qr-item">
                    <div className="qr-image">
                      <img src={qr.image_data} alt={`QR code for ${qr.content}`} />
                    </div>
                    <div className="qr-details">
                      <p className="qr-content">{qr.content}</p>
                      <p className="qr-date">
                        Created: {new Date(qr.created_at).toLocaleString()}
                      </p>
                      <div className="qr-actions">
                        <button 
                          onClick={() => downloadQrCode(qr.image_data, qr.content)}
                          className="download-btn"
                        >
                          Download
                        </button>
                        <button 
                          onClick={() => handleDelete(qr.id)}
                          className="delete-btn"
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </main>
    </div>
  );
}

export default App;
